import React, { useState } from 'react'
import Modal from '../../../ReusableComponents/Modal';
import { nameValidation } from '../../../utils/inputValidations';
import { Button } from '../../../Components/Helper';
import Form from '../../../ReusableComponents/Form';
import InputField from '../../../ReusableComponents/InputField';
import { debitIncentiveForCancelRequest } from '../../../apis/BhuMeetTeams/Oparations/besIncentive';
import Loading from '../../../ReusableFunctions/Loader';
import Popup from '../../../ReusableFunctions/Popup';

export default function DebitIncentiveModal({
    open,
    onClose,
    requestData,
    onSuccess,
}) {
    const [debitIncentive, setebitIncentive] = useState({
        reason:""
    })

    const debitIncentiveFunc=async(reqId,reqNumber,reason)=>{
        try{
        Loading.set(true);
           let res= await debitIncentiveForCancelRequest(reqId,reqNumber,reason);
           Loading.set(false);
           Popup.alert("SUCCESS","Incentive Debit successfully","SUCCESS");
           onClose();
           onSuccess();
        }catch(err){
            Popup.alert("ERROR",err || "something went wrong while debit incentive","ERROR");
           Loading.set(false);
        }

    }
  return (
    <Modal
    header={"Debit Incentive Reason"}
    open={open}
    onClose={onClose}
    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
>
    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '100%' }}>
        <Form
            onSubmitForm={async(data) => {
                debitIncentiveFunc(requestData?.reqId,requestData?.reqNumber,data?.reason)
            }}
            initialValues={debitIncentive}
            style={{
                display: "flex",
                flexDirection: "column",
                fontSize: "11px",
                gap: "50px"
            }}
        >
            {(onsubmit) => (
                <>
                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", rowGap: "5px" }}>
                        <InputField
                            label={"Reason"}
                            type={"text"}
                            id={"name"}
                            placeholder={"Enter reason for debit incenntive"}
                            name={"reason"}
                            validation={nameValidation}
                            containerStyle={{
                                rowGap: "15px"
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            padding: "10px 0px 10px 10px",
                            gap: "20px"
                        }}
                    >
                        <Button
                            text={"Debit"}
                            onClick={onsubmit}
                            style={{ width: "90px",height:"30px" }}
                        />
                        <Button
                            text={"Cancel"}
                            onClick={onClose}
                            isBtnNotActive={true}
                            style={{ width: "90px",height:"30px" }}
                        />
                    </div>
                </>
            )}
        </Form>
    </div>
</Modal>
  )
}
